import { SelectionState, Modifier, EditorState } from "draft-js";
import React, { useState, useEffect, useRef } from "react";
import { COLOR_DARK_RED } from "shared/theme/colors";
import { DeleteIcon } from "shared/theme/icons/DeleteIcon";
import ImageSkeleton from "../ImageSkeleton";
import {
  StyledImageContainer,
  StyledImageActionContainer,
  StyledImageActionText,
  StyledImageButton,
} from "./styled";

const ImageComponent = (props: any) => {
  const [isLoading, setIsLoading] = useState(true);
  const imgRef = useRef<HTMLImageElement>(null);

  const { block, contentState } = props;
  const entityKey = block.getEntityAt(0);

  useEffect(() => {
    if (imgRef.current) {
      if (imgRef.current.complete) {
        setIsLoading(false);
      } else {
        imgRef.current.onload = () => setIsLoading(false);
        imgRef.current.onerror = () => {
          console.error("Image failed to load");
          setIsLoading(false);
        };
      }
    }
  }, []);

  if (!entityKey) {
    return null;
  }

  const entity = contentState.getEntity(entityKey);
  const { src } = entity.getData();
  const imageName = decodeURIComponent(
    src.split("/").pop()?.split("?")[0].split("-").pop() || "",
  );

  const handleDelete = () => {
    const blockKey = block.getKey();
    const targetRange = new SelectionState({
      anchorKey: blockKey,
      anchorOffset: 0,
      focusKey: blockKey,
      focusOffset: block.getLength(),
    });
    const newContentState = Modifier.removeRange(
      contentState,
      targetRange,
      "backward",
    );
    props.blockProps.onChange(
      EditorState.push(
        props.blockProps.getEditorState(),
        newContentState,
        "remove-range",
      ),
    );
  };

  return (
    <StyledImageContainer>
      {isLoading && <ImageSkeleton />}
      <img
        ref={imgRef}
        src={src}
        className="draft-editor-image"
        alt={imageName}
        style={{
          ...props.style,
          display: isLoading ? "none" : "inline-block",
        }}
      />
      {!isLoading && (
        <StyledImageActionContainer>
          <StyledImageActionText>{imageName}</StyledImageActionText>
          <StyledImageButton onClick={handleDelete}>
            <DeleteIcon size={24} color={COLOR_DARK_RED} />
          </StyledImageButton>
        </StyledImageActionContainer>
      )}
    </StyledImageContainer>
  );
};

export default ImageComponent;
